<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <div
                    v-for="object in beforeAfterArray"
                    :key="object.payCode"
                    class="mt-3.5 md:mt-5 first:mt-0"
                >
                    <h4>{{ object.payCodeName }}</h4>
                    <div
                        v-for="(item,idx) in object.beneFiBankAccountList"
                        :key="idx"
                    >
                        <div class="pb-2.5 mt-2.5  text-base text-black font-bold">
                            受益人：{{ item.beneFiName }} {{ item.beneFiId }}
                        </div>
                        <ChangeBeforeAfter>
                            <template #before>
                                <div class="md:flex md:w-full divide-y md:divide-none divide-dashed">
                                    <div class="flex md:w-1/6 dashed">
                                        <div class="title">
                                            戶名
                                        </div>
                                        <div class="content">
                                            {{ item.before.bankAccountName?item.before.bankAccountName:'未指定' }}
                                        </div>
                                    </div>
                                    <div class="flex md:w-3/6 dashed">
                                        <div class="title">
                                            銀行
                                        </div>
                                        <div class="content">
                                            <div
                                                v-if="item.before.branchBankNo|| item.before.headBankNo"
                                                class="md:flex md:flex-wrap"
                                            >
                                                <p class="break-all md:mr-1">
                                                    {{ !object.foreignAccount?item.before.branchBankNo:item.before.headBankNo }}
                                                </p>
                                                <p>
                                                    {{ !object.foreignAccount?item.before.branchBankName:item.before.headBankName }}
                                                </p>
                                            </div>
                                            <div v-else>
                                                未指定
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex md:w-2/6 dashed">
                                        <div class="title">
                                            帳號
                                        </div>
                                        <div class="content">
                                            {{ item.before.bankAccount?item.before.bankAccount:'未指定' }}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template #after>
                                <div class="md:flex md:w-full divide-y md:divide-none divide-dashed">
                                    <div class="flex md:w-1/6 dashed">
                                        <div class="title">
                                            戶名
                                        </div>
                                        <div class="content">
                                            {{ item.after.bankAccountName }}
                                        </div>
                                    </div>
                                    <div class="flex md:w-3/6 dashed">
                                        <div class="title">
                                            銀行
                                        </div>
                                        <div class="content">
                                            <div
                                                v-if="item.after.branchBankNo|| item.after.headBankNo"
                                                class="md:flex md:flex-wrap"
                                            >
                                                <p class="break-all md:mr-1">
                                                    {{ !object.foreignAccount?item.after.branchBankNo:item.after.headBankNo }}
                                                </p>
                                                <p>
                                                    {{ !object.foreignAccount?item.after.branchBankName:item.after.headBankName }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex md:w-2/6 dashed">
                                        <div class="title">
                                            帳號
                                        </div>
                                        <div class="content">
                                            {{ item.after.bankAccount }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </ChangeBeforeAfter>
                    </div>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, computed } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'B6Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const beforeAfterArray = computed(() => {
            const array = [];
            data.value.before.beneFiPayCodeList.forEach(i => {
                data.value.after.beneFiPayCodeList.forEach(j => {
                    if (i.payCode === j.payCode) {
                        const obj = {};
                        obj.payCode = i.payCode;
                        obj.payCodeName = i.payCodeName;
                        obj.foreignAccount = data.value.before.foreignAccount;
                        obj.beneFiBankAccountList = [];
                        i.beneFiBankAccountList.forEach(k => {
                            j.beneFiBankAccountList.forEach(l => {
                                if (k.uuid === l.uuid) {
                                    const minorObj = {};
                                    minorObj.beneFiId = k.beneFiId;
                                    minorObj.beneFiName = k.beneFiName;
                                    minorObj.before = k;
                                    minorObj.after = l;
                                    obj.beneFiBankAccountList.push(minorObj);
                                }
                            });
                        });
                        array.push(obj);
                    }
                });
            });
            return array;
        });
        const code = ref('B6');
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, beforeAfterArray, removeService };
    },
};
</script>
<style scoped lang="scss">
.dashed {
    @apply pt-1 first:pt-0 md:pt-0 pb-1 last:pb-0 md:pb-0 md:pr-2.5 last:md:pr-0;
}
.title {
    @apply flex-shrink-0 text-sm leading-7 mr-3.5 md:hidden;
}
.content {
    @apply text-lg text-gray-700;
}
</style>
